module.exports = __webpack_public_path__ + "static/icons/preview1.6548f1f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/login/preview1.jpg
// module id = rSSQ
// module chunks = 1